import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase'; // Asegúrate de que la ruta sea correcta

const GlobalConfigContext = createContext();

export const GlobalConfigProvider = ({ children }) => {
    const [appFeatures, setAppFeatures] = useState([]);
    const [currenciesType, setCurrenciesType] = useState('USD');
    const [transactionTypes, setTransactionTypes] = useState([]);

    // Listener en tiempo real para configuraciones globales
    useEffect(() => {
        const settingsDocRef = doc(db, 'settings', 'global'); // Referencia al documento
        const unsubscribe = onSnapshot(settingsDocRef, (docSnapshot) => {
            if (docSnapshot.exists()) {
                const settings = docSnapshot.data();
                setAppFeatures(settings.appFeatures || []);
                setCurrenciesType(settings.currenciesType || 'USD');
                setTransactionTypes(settings.transactionTypes || []);
            } else {
                console.warn('El documento "global" no existe en la colección "settings".');
            }
        }, (error) => {
            console.error('Error al escuchar los cambios en las configuraciones:', error);
        });

        // Limpiar el listener al desmontar el componente
        return () => unsubscribe();
    }, []);

    const value = useMemo(() => ({
        appFeatures,
        setAppFeatures,
        currenciesType,
        setCurrenciesType,
        transactionTypes,
        setTransactionTypes,
    }), [appFeatures, currenciesType, transactionTypes]);

    return (
        <GlobalConfigContext.Provider value={value}>
            {children}
        </GlobalConfigContext.Provider>
    );
};

export const useGlobalConfig = () => {
    return useContext(GlobalConfigContext);
};